import React, { useState, useEffect } from "react";
import { createAPIEndpoint, Endpoint } from "../../Services/FOCservice";
import storage from "../../Services/Storage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import Axios from "../../api/Axios";
import { createAPIEndpointMessage, EndpointMessage } from "../../Services/MessageService";
import { toast } from "react-toastify";
import * as Fa from "react-icons/fa";
// import isEqual from "lodash/isEqual";
import { useGlobalContext1 } from "../../context/SalesDetailsContext";
import Print from "../InvoicePrint/NewPrintInvoice";
import Loader from "../../Components/Loader";
import { format } from "date-fns";

let pdtCode;
let pdtLot;
let pdtOrder;
let pdtBack;
export default function ViewFOC()  {
    const auth = storage.getLocal("user");
    const [autoFocData, setAutoFOCData] = useState();
    const [autoFOCProductData, setAutoFOCProductData] = useState();
    const [selectedFOCRow, setSelectedFOCRow] = useState([]);
    // const [selectedDisableRow, setSelectedDisableRow] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const location = useLocation();
    const data = location?.state;
    // const [releaseQty, setReleaseQty] = useState("");
    const reallocation = "SalesOrder/ReAllocation";
    const addToCartURL = "AutoFOC/AddToCart";
    // const SaveURL = "AutoFOC/SaveFOCData";
    const INSERT_SO = "SalesOrder/UPsertSOData";
    const apicalling = "SalesOrder/GetCustomerInformation?";
    const CREATE_INVOICE = "AutoFOC/createInvoice";
    // const [addToCartData, setAddToCartData] = useState([]);
    // const [SODetailsData, setSODetailsData] = useState();
    const [SalesOrderData, setSalesOrderData] = useState();
    const [productData, setProductData] = useState();
    // const getCustomerInfoByCustId_URL = "CustomerMast/GetCustomerInfoByCustId?";
    // const custInfo_api = `${getCustomerInfoByCustId_URL}CICode=${auth.CICode}&CustId=${data.CUST_ID}&CompId=${auth.CompId}`;
    // const [custInfoData, setCustInfoData] = useState();
    const [loading, setLoading] = useState(false);
    const [reallocateData, setReallocateData] = useState();
    const [btnDisable, setBtnDisable] = useState(true);

    //concurrency control
    const[concurrentUser, setConcurrentUser] = useState(false);
    const[restrictedMsg, setRestrictedMsg] = useState("");
    const[lastModifiedOn,setLastModifiedOn] = useState();

    const { invoicePopup, setInvoicePopup, setPrintInvoiceModalData } = useGlobalContext1();
    const nav = useNavigate();
    let date = new Date();
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();
    const currentDate = `${day}/${month}/${year}`.toString();
    // function ToDecimal(data) {
    //     const result = Number(data).toFixed(2);
    //     if (data == null || data == undefined) {
    //         return 0.0;
    //     }
    //     return result;
    // }
    // const getCustInfo = async () => {
    //     setLoading(false);
    //     try{
    //         const custInfoRes = await Axios.get(custInfo_api);
    //         console.log("custInfoRes custInfoRes ", custInfoRes);
    //         setCustInfoData(custInfoRes);
    //     }catch(ex){
    //         console.log(ex);
    //     }finally{
    //         setLoading(true);
    //     }
    // };
    const UpdateSalesCondition = async (type) => {
        try{
            if(type == "INV"){
                setBtnDisable(true);
            }
            const response = await createAPIEndpoint().get(`${Endpoint.GetAutoFOCBySOHD_ID}?SOHD_ID=${data.MASK_SO_ID}&Tag=${"N"}&LangId=1&UserId=${auth.UserId}`);
            const apiDate = new Date(response?.data[0]?.LAST_MODIFIED_ON);
            const compareDate = new Date(lastModifiedOn);
            if (apiDate > compareDate) {
                setConcurrentUser(true);
                setRestrictedMsg("This order is in use by another user. Please try after sometime.");
                setBtnDisable(false);
            } else {
                setLastModifiedOn(response?.data[0]?.LAST_MODIFIED_ON);
                if(type == "FOCUP"){
                    saveFocData();
                }
                else if(type == "INV"){
                    invoiceCall();
                }
            }
        }catch(ex){
            setConcurrentUser(true);
            setRestrictedMsg("This order is in use by another user. Please try after sometime.");
            setBtnDisable(false);
        }
    };
    const getAutoFOCBySOHD_ID_Data = async () => {
        console.log(data,"getAutoFOCBySOHD_ID_Data");
        setLoading(true);
        try {
            // const response = await createAPIEndpoint().get(`${Endpoint.GetAutoFOCBySOHD_ID}?SOHD_ID=${data?.MASK_SO_ID}&Tag=${'N'}&LangId=1&UserId=${'13300026_CO1'}`);
            const response = await createAPIEndpoint().get(`${Endpoint.GetAutoFOCBySOHD_ID}?SOHD_ID=${data.MASK_SO_ID}&Tag=${"N"}&LangId=1&UserId=${auth.UserId}`);
            console.log("response.data getAutoFOCBySOHD_ID_Data autoFocData ", response.data);
            setAutoFOCData(response?.data);
            setLastModifiedOn(response?.data[0]?.LAST_MODIFIED_ON);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoading(false);
        }
    };

    const getAutoFOCProductDetailsData = async () => {
        setLoading(true);
        try {
            const response = await createAPIEndpoint().get(`${Endpoint.GetAutoFOCProductDetails}?strSalesOrderId=${data?.MASK_SO_ID}&LangId=1`);
            console.log("response.datag etAutoFOCProductDetailsData product autoFOCproductDetail", response.data);

            setAutoFOCProductData(response?.data);
            getAutoFOCBySOHD_ID_Data();
            const totalQty = response?.data.reduce((sum, item) => sum + Number(item.TOT_REL_QTY), 0);
            console.log(totalQty,"totalQty");
            if(totalQty==0){
                setBtnDisable(true);
            }
            else{
                setBtnDisable(false);
            }
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoading(false);
        }
    };
    const ToDecimal = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };
    const addToCartValidations = async () => {
        try {
            console.log(SalesOrderData,"SalesOrderData");
            for (let rowData = 0; rowData < SalesOrderData.length; rowData++) {
                if (ToDecimal(SalesOrderData[rowData]?.BALANCED_QTY?.toString()) < ToDecimal(SalesOrderData[rowData]?.PACK_REL_QTY?.toString())) {
                    const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=QTY0077`);
                    toast.error(res.data, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    return;
                }

            }
            console.log(productData,"FOCproductData");
            let tot_inv_qty = isNaN(Number(productData[0].TOT_INV_QTY))?0:Number(productData[0].TOT_INV_QTY);
            let tot_rel_qty = isNaN(Number(productData[0].TOT_REL_QTY))?0:Number(productData[0].TOT_REL_QTY);
            let tot_ord_qty = isNaN(Number(productData[0].TOT_ORD_QTY))?0:Number(productData[0].TOT_ORD_QTY);
            let tot_drop_qty = isNaN(Number(productData[0].MASK_TOT_DROP_QTY))?0:Number(productData[0].MASK_TOT_DROP_QTY);
            if (tot_drop_qty + tot_inv_qty + tot_rel_qty > tot_ord_qty) {
                toast.error(`Please change Release quantity, already Invoiced quantity : ${tot_inv_qty}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
            handleReallocateReleaseQty();

        } catch (error) {
            // const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=QTY0077`);
            //         toast.error(res.data, {
            //             position: toast.POSITION.TOP_CENTER,
            //             pauseOnFocusLoss: false,
            //             closeButton: false,
            //             autoClose: 3000,
            //         });
            //         return;
            console.log("error ", error);
        }
    };
    console.log(data,"data");
    const handleReallocateReleaseQty = async () => {
        
        let obj = {
            AddToCart: "",
            CICode: auth.CICode,
            CustId: data.CUST_ID,
            // salesOrderHdr.MASK_CUST_ID,
            //ComboProduct: reallocateData[0].MASK_PROD_ID,
            soHrdId: data.MASK_SO_ID,
            UserId: auth.UserId,
            OrderQty: reallocateData[0].TOT_ORD_QTY?.toString(),
            InvQty: reallocateData[0].TOT_INV_QTY?.toString(),
            CompId: auth.CompId,
            TradeDiscPer: "0",
            PrintFormatCode: auth.PrintFormatCode,
            UOM: "2",
            strDivnId: reallocateData[0].MASK_DIVN_ID,
            StockType: reallocateData[0].MASK_SODT_PROD_STK_TYPE,
            SubProd: SalesOrderData.map((a) => ({
                // ...a,
                MASK_PROD_ID:a.MASK_PROD_ID,
                PRODUCT_CODE:a.PRODUCT_CODE,
                MASK_PROD_PACK_DESC:a.MASK_PROD_PACK_DESC,
                PROD_BATCH_NO:a.PROD_BATCH_NO,
                BALANCED_QTY: a.BALANCED_QTY === "" ? "0" : a.BALANCED_QTY.toString(),
                PACK_REL_QTY:a.PACK_REL_QTY,
                PROD_MRP:a.PROD_MRP,
                PROD_UNIT_PRICE:a.PROD_UNIT_PRICE.toString(),
                // BALANCED_QTY: a.BALANCED_QTY === "" ? "0" : a.BALANCED_QTY.toString(),
            })),
            SODetailsData: selectedFOCRow.map((a) => ({
                MASK_SODT_ID:a.MASK_SODT_ID,
                DIVISION:a.DIVISION ,
                MASK_PROD_ID:a.MASK_PROD_ID ,
                STOCK_TYPE:a.STOCK_TYPE,
                PRODUCT_CODE:a.PRODUCT_CODE ,
                PROD_SMALL_DESC:a.PROD_SMALL_DESC ,
                PROD_LOT_NO:a.PROD_LOT_NO ,
                PRICE_LIST_NO:a.PRICE_LIST_NO ,
                CASE_TYPE: a.CASE_TYPE,
                CDR_DISC:a.CDR_DISC ,
                EUS_DISC_PERC:a.EUS_DISC_PERC.toString(),
                EUS_DISC:a.EUS_DISC.toString() ,
                CASE_ORD_QTY:a.CASE_ORD_QTY.toString() ,
                PACK_ORD_QTY:a.PACK_ORD_QTY.toString() ,
                TOT_ORD_QTY:a.TOT_ORD_QTY.toString() ,
                PROD_PRICE:a.PROD_PRICE.toString(),
                BASE_PRICE:a.BASE_PRICE.toString() ,
                CASE_REL_QTY:a.CASE_REL_QTY.toString(),
                PACK_REL_QTY:a.PACK_REL_QTY.toString() ,
                TOT_REL_QTY:a.TOT_REL_QTY.toString() ,
                TOT_INV_QTY:a.TOT_INV_QTY.toString(),
                MASK_PROD_VAL:a.MASK_PROD_VAL.toString() ,
                MASK_SODT_PROD_STK_TYPE:a.MASK_SODT_PROD_STK_TYPE ,
                MASK_PACK_UOM_CODE:a.MASK_PACK_UOM_CODE ,
                MASK_TOT_BACK_QTY:a.MASK_TOT_BACK_QTY.toString() ,
                MASK_TOT_DROP_QTY:a.MASK_TOT_DROP_QTY.toString() ,
                MASK_TRADE_DISC:a.MASK_TRADE_DISC.toString() ,
                MASK_VAL_BASE_CRNC:a.MASK_VAL_BASE_CRNC.toString(),
                MASK_SPLCON_TAX:a.MASK_SPLCON_TAX.toString() ,
                MASK_TOT_TAX:a.MASK_TOT_TAX.toString() ,
                MASK_SODT_TOT_VAT:a.MASK_SODT_TOT_VAT.toString(),
                MASK_CASE_FACTOR:a.MASK_CASE_FACTOR.toString() ,
                MASK_STATUS:a.MASK_STATUS,
                MASK_UPDATE_COUNT:a.MASK_UPDATE_COUNT.toString(),
                MASK_EXPORTED:a.MASK_EXPORTED,
                MASK_FIRST_ENTERED_BY:a.MASK_FIRST_ENTERED_BY ,
                MASK_FIRST_ENTERED_ON:a.MASK_FIRST_ENTERED_ON ,
                MASK_LAST_MODIFIED_BY:a.MASK_LAST_MODIFIED_BY ,
                MASK_LAST_MODIFIED_ON:a.MASK_LAST_MODIFIED_ON ,
                MASK_IUKEY:a.MASK_IUKEY ,
                MASK_SEQUENCE:a.MASK_SEQUENCE!=null?a.MASK_SEQUENCE.toString():a.MASK_SEQUENCE ,
                EXTENDED_PRICE:a.EXTENDED_PRICE.toString(),
                MASK_SODT_EUS_DISC_PERC_TAG:a.MASK_SODT_EUS_DISC_PERC_TAG ,
                MASK_SODT_TRANS_VAL:a.MASK_SODT_TRANS_VAL.toString() ,
                MASK_SODT_CDR_DISC_PERC:a.MASK_SODT_CDR_DISC_PERC.toString() ,
                MASK_SODT_CDR_DISC_PERC_TAG:a.MASK_SODT_CDR_DISC_PERC_TAG ,
                MASK_SODT_PRICE_OR_TAG:a.MASK_SODT_PRICE_OR_TAG ,
                MASK_SODT_UPPER_BAND:a.MASK_SODT_UPPER_BAND ,
                MASK_SODT_LOWER_BAND:a.MASK_SODT_LOWER_BAND ,
                MASK_SODT_PRL_PRICE:a.MASK_SODT_PRL_PRICE ,
                MASK_SOHD_ID:a.MASK_SOHD_ID ,
                MASK_DIVN_ID:a.MASK_DIVN_ID ,
                MASK_EVAL_BY_LOT_TAG:a.MASK_EVAL_BY_LOT_TAG ,
                MASK_EUS_DISC_APP_TO:a.MASK_EUS_DISC_APP_TO ,
                MASK_PRODUCT_MRP:a.MASK_PRODUCT_MRP.toString() ,
                MASK_TOT_REL_QTY: a.MASK_TOT_REL_QTY.toString(),
                MASK_OLD_STK_ONLY:a.MASK_OLD_STK_ONLY ,
                RBO_REAS_CODE:a.RBO_REAS_CODE ,
                BASE_PROD_ALLOC:a.BASE_PROD_ALLOC ,
                STOCK_TYP:a.STOCK_TYP ,
                DESCRIPTION:a.DESCRIPTION ,
                TOT_AVL_QTY:a.TOT_AVL_QTY,
                // MASK_UPDATE_COUNT: a.MASK_UPDATE_COUNT.toString(),
                BASE_PROD_CODE: a.BASE_PROD_CODE,
                BASE_PROD_LOT: a.BASE_PROD_LOT,
            })),
            OEMORDER: "",
        };
        try {
            console.log("obj ", obj);
            const res = await Axios.post(addToCartURL, JSON.stringify(obj), {
                headers: { "Content-Type": "application/json" },
            });
            if (res.data.SODetailsData !== null) {
                if ((autoFOCProductData.length - 1) + res.data.SODetailsData.length > 24) {
                    toast.warn("Order should not exceed 24 line items", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }else {
                    let _autoFOCProductData = autoFOCProductData.filter(
                        (a) => a.PRODUCT_CODE + a.PROD_LOT_NO + a.PACK_ORD_QTY + a.MASK_TOT_BACK_QTY !== pdtCode + pdtLot + pdtOrder + pdtBack
                    );
                    // res.data.SODetailsData.forEach((a) => {
                    //     _filteredSalesDetails.push({ ...a });
                    // });
                    setAutoFOCProductData(_autoFOCProductData);
                    const newData = res.data.SODetailsData;
                    const quantityFieldsToSum = [
                        "TOT_ORD_QTY",
                        "PACK_ORD_QTY",
                        "CASE_ORD_QTY",
                        "CASE_REL_QTY",
                        "PACK_REL_QTY",
                        "TOT_INV_QTY",
                        "TOT_REL_QTY",
                        "MASK_TOT_BACK_QTY",
                        "MASK_TOT_DROP_QTY",
                        "MASK_TOT_REL_QTY",
                        "BASE_PRICE",
                        "EXTENDED_PRICE",
                        "MASK_PROD_VAL",
                        "MASK_SODT_TOT_VAT"
                    ];
                    const parseNumber = (val) => parseFloat(val || "0") || 0;
                    // for (let i = 0; i < res.data.SODetailsData.length; i++) {
                    //     setAutoFOCProductData((current) => [...current, res.data.SODetailsData[i]]);
                    // }
                    console.log(autoFOCProductData,newData,"newData");
                    setAutoFOCProductData((current) => {
                        const merged = [...current]; // clone existing items
                    
                        newData.forEach((newItem) => {
                            const index = merged.findIndex(
                                (item) =>
                                    item.PRODUCT_CODE === newItem.PRODUCT_CODE &&
                                    item.PROD_LOT_NO === newItem.PROD_LOT_NO
                            );
                            
                            if (index > -1) {
                                const existingItem = merged[index];
                                const updatedItem = { ...existingItem };

                                if (newItem.BASE_PROD_CODE) {
                                    updatedItem.BASE_PROD_CODE = newItem.BASE_PROD_CODE;
                                }

                                quantityFieldsToSum.forEach((field) => {
                                    updatedItem[field] = (
                                        parseNumber(existingItem[field]) + parseNumber(newItem[field])
                                    ).toString();
                                });
                            
                                merged[index] = updatedItem;
                            } else {
                                // New combination, add it
                                merged.push(newItem);
                            }
                        });
                    
                        return merged;
                    });
                    // for (let i = 0; i < res.data.SODetailsData.length; i++) {
                    //     setAutoFOCProductData((current) => {
                    //         const newItem = res.data.SODetailsData[i];
                    //         const exists = current.some((item) => isEqual(item, newItem));
                        
                    //         if (!exists) {
                    //             return [...current, newItem];
                    //         }
                        
                    //         return current;
                    //     });
                    // }
                }
            } else setAutoFOCProductData(autoFOCProductData);
            toast.success("Data added to cart successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } 
        catch (error) {
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
             
        }finally{
            setShowDialog(false);
        }
    };

    function convertData(rowData) {
        console.log(rowData,"rowData");
        setReallocateData(rowData);
        const _soDetailsData = rowData.map((data) => ({
            MASK_SODT_ID: data.MASK_SODT_ID,
            DIVISION: data.MASK_DIVN_ID,
            MASK_PROD_ID: data.MASK_PROD_ID,
            PRODUCT_CODE: data.PRODUCT_CODE,
            DESCRIPTION: data.PROD_SMALL_DESC,
            PROD_SMALL_DESC: data.PROD_SMALL_DESC,
            PROD_LOT_NO: data.PROD_LOT_NO,
            PRICE_LIST_NO: data.PRICE_LIST_NO,
            CASE_TYPE: data.CASE_TYPE,
            CDR_DISC: data.CDR_DISC,
            EUS_DISC_PERC: data.EUS_DISC_PERC?.toString(),
            EUS_DISC: data.EUS_DISC,
            CASE_ORD_QTY: data.CASE_ORD_QTY?.toString(),
            PACK_ORD_QTY: data.PACK_ORD_QTY?.toString(),
            TOT_ORD_QTY: data.TOT_ORD_QTY?.toString(),
            PROD_PRICE: data.PROD_PRICE,
            BASE_PRICE: data.BASE_PRICE,
            CASE_REL_QTY: data.CASE_REL_QTY?.toString(),
            PACK_REL_QTY: data.PACK_REL_QTY?.toString(),
            TOT_REL_QTY: data.TOT_REL_QTY?.toString(),
            TOT_INV_QTY: data.TOT_INV_QTY?.toString(),
            MASK_PROD_VAL: data.MASK_PROD_VAL,
            MASK_SODT_PROD_STK_TYPE: data.MASK_SODT_PROD_STK_TYPE,
            MASK_PACK_UOM_CODE: data.MASK_PACK_UOM_CODE,
            MASK_TOT_BACK_QTY: data.MASK_TOT_BACK_QTY?.toString(),
            MASK_TOT_DROP_QTY: data.MASK_TOT_DROP_QTY?.toString(),
            MASK_TRADE_DISC: data.MASK_TRADE_DISC,
            MASK_VAL_BASE_CRNC: data.MASK_VAL_BASE_CRNC,
            MASK_SPLCON_TAX: data.MASK_SPLCON_TAX,
            MASK_TOT_TAX: data.MASK_TOT_TAX,
            MASK_SODT_TOT_VAT: data.MASK_SODT_TOT_VAT,
            MASK_CASE_FACTOR: data.MASK_CASE_FACTOR?.toString(),
            MASK_STATUS: data.MASK_STATUS,
            MASK_EXPORTED: data.MASK_EXPORTED,
            MASK_FIRST_ENTERED_BY: data.MASK_FIRST_ENTERED_BY,
            MASK_FIRST_ENTERED_ON: data.MASK_FIRST_ENTERED_ON,
            MASK_LAST_MODIFIED_BY: data.MASK_LAST_MODIFIED_BY ? data.MASK_LAST_MODIFIED_BY : "",
            MASK_LAST_MODIFIED_ON: data.MASK_LAST_MODIFIED_ON ? data.MASK_LAST_MODIFIED_ON : "",
            MASK_IUKEY: data.MASK_IUKEY,
            MASK_SEQUENCE: data.MASK_SEQUENCE ? data.MASK_SEQUENCE : "",
            EXTENDED_PRICE: data.EXTENDED_PRICE,
            MASK_SODT_EUS_DISC_PERC_TAG: data.MASK_SODT_EUS_DISC_PERC_TAG,
            MASK_SODT_TRANS_VAL: data.MASK_SODT_TRANS_VAL,
            MASK_SODT_CDR_DISC_PERC: data.MASK_SODT_CDR_DISC_PERC,
            MASK_SODT_CDR_DISC_PERC_TAG: data.MASK_SODT_CDR_DISC_PERC_TAG,
            MASK_SODT_PRICE_OR_TAG: data.MASK_SODT_PRICE_OR_TAG,
            MASK_SODT_UPPER_BAND: data.MASK_SODT_UPPER_BAND,
            MASK_SODT_LOWER_BAND: data.MASK_SODT_LOWER_BAND,
            MASK_SODT_PRL_PRICE: data.MASK_SODT_PRL_PRICE,
            MASK_SOHD_ID: data.MASK_SOHD_ID,
            MASK_DIVN_ID: data.MASK_DIVN_ID,
            MASK_EVAL_BY_LOT_TAG: data.MASK_EVAL_BY_LOT_TAG,
            MASK_EUS_DISC_APP_TO: data.MASK_EUS_DISC_APP_TO,
            MASK_PRODUCT_MRP: data.MASK_PRODUCT_MRP,
            MASK_TOT_REL_QTY: data.MASK_TOT_REL_QTY?.toString(),
            MASK_OLD_STK_ONLY: data.MASK_OLD_STK_ONLY,
            RBO_REAS_CODE: data.RBO_REAS_CODE,//"REAS/54",
            STOCK_TYP: "1",
            STOCK_TYPE: "1",
            TOT_AVL_QTY: data.TOT_AVL_QTY ? data.TOT_AVL_QTY : null,
            MASK_UPDATE_COUNT: data.MASK_UPDATE_COUNT.toString(),
            UPDATE_COUNT: data.MASK_UPDATE_COUNT.toString()

        }));

        const obj = {
            CICode: auth.CICode,
            CompId: auth.CompId,
            CustId: autoFocData[0].MASK_CUST_ID,
            LotNo: rowData[0].PROD_LOT_NO,
            OddLotNo: "",
            OddOrderQty: "",
            ComboProduct: rowData[0].MASK_PROD_ID,
            ComboOddLotProduct: "",
            OrderQty: rowData[0].TOT_ORD_QTY?.toString(),
            ReallocateProdId: rowData[0].MASK_PROD_ID,
            ComboFreeProduct: "",
            OEMORDER: "TATA",
            StockType: "1",
            Tag: "N",
            UserId: auth.UserId,
            PrintFormatCode: auth.PrintFormatCode ? auth.PrintFormatCode : null,
            UOM: "2",
            UOMCode: "EA",
            CurrencyId: "INR",
            CurrencyCode: "2",
            strDivnId: rowData[0].MASK_DIVN_ID,
            ISBASKET:"N",
            SODetailsData: _soDetailsData,
        };

        return obj;
    }

    const getReallocateData = async (rowData) => {
        setLoading(true);
        const payload = convertData(rowData);
        setProductData(rowData);
        try {
            const res = await Axios.post(reallocation, JSON.stringify(payload), {
                headers: { "Content-Type": "application/json" },
            });
            if (res.data?.Status == "Success") {
                // setSODetailsData(res.data.SODetailsData);
                // setSalesOrderData(res.data.SalesOrder);
                const reallocationFilter = res.data.SalesOrder.filter(
                    (val) => Number(val.BALANCED_QTY) >= 0
                );
                // setSelectedSalesDetails(row);
                reallocationFilter.sort((a, b) => {
                    return b.PACK_REL_QTY - a.PACK_REL_QTY;
                });
                const filterDisable = autoFOCProductData.filter((a)=>{return a.PRODUCT_CODE+a.PROD_LOT_NO!==rowData[0].PRODUCT_CODE+rowData[0].PROD_LOT_NO;});
                console.log(filterDisable,"filterDisable");
                // setSelectedDisableRow(filterDisable);
                if(filterDisable.some((a)=>a.PRODUCT_CODE+a.PROD_LOT_NO===rowData[0].MASK_PROD_ID+rowData[0].PROD_LOT_NO)){
                    const updateReallocationFilter = {
                        ...reallocationFilter,
                        PACK_REL_QTY:0
                    };
                    setSalesOrderData(updateReallocationFilter);
                }
                else{
                    setSalesOrderData(reallocationFilter);
                }
                pdtCode = rowData[0].PRODUCT_CODE;
                pdtLot = rowData[0].PROD_LOT_NO;
                pdtOrder = rowData[0].TOT_ORD_QTY;
                pdtBack = rowData[0].MASK_TOT_BACK_QTY;
                setSelectedFOCRow(rowData);
                console.log(rowData,"selectedFOCRow");
            }
            console.log("res res getReallocateData soDetailData ", res.data);

        } catch (error) {
            console.log("error ", error);

        }finally{
            setLoading(false);
        }

    };

    // function changeDateFormat(inputDate) {
    //     if(inputDate !== null && typeof inputDate === "string" ){
    //         const [day, month, year] = inputDate.split("/");
    //         const formattedDate = `${day}/${month}/${year}`;
    //         return formattedDate;
    //     }
    //     else{
    //         return null;
    //     }
    // }
    function changeDateFormatMMDD(inputDate) {
        if (inputDate !== null && typeof inputDate === "string") {
            const [day, month, year] = inputDate.split("/");
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        } else {
            return null;
        }
    }
    const createSavePayload = () => {
        console.log(autoFOCProductData,"pay load for save");
        let docPayTermData = autoFocData.map((a) => ({
            COMP_ID: auth.CompId,
            DOC_ID: a.MASK_SO_ID,
            PAY_TERM_ID: a.MASK_PAY_TERM_ID,
            DOC_TYPE: "",
            DUE_DATE: changeDateFormatMMDD(a.MASK_SOHD_PROMISED_DUE_DATE),
            // DUE_DATE: format(a.MASK_SOHD_PROMISED_DUE_DATE,"dd/MM/yyyy"),
            TYPE: "",
        }));
        let _salesOrderHdr = autoFocData.map((a) => ({
            SOHD_ID: a.MASK_SO_ID,
            SOHD_SO_NO: a.SO_NO,
            SOHD_SO_DATE: changeDateFormatMMDD(a.SO_DATE),
            SOHD_TYPE: a.MASK_SOHD_TYPE,
            COMP_ID: a.MASK_COMP_ID,
            DIVN_ID: "GEN",
            //  DIVN_ID:a.MASK_DIVN_ID,
            SOHD_REQ_DEL_DATE: changeDateFormatMMDD(a.MASK_SOHD_REQ_DEL_DATE),
            SOHD_PROMISED_DUE_DATE: changeDateFormatMMDD(a.MASK_SOHD_PROMISED_DUE_DATE),
            CURRENCY_ID: a.MASK_CURRENCY_ID,
            SOHD_EXCH_RATE: a.MASK_SOHD_EXCH_RATE,
            SOHD_TRADE_DISC_PERC: a.MASK_SOHD_TRADE_DISC_PERC??"0",
            ORD_MODE_ID: a.MASK_ORD_MODE_ID,
            MOP_ID: a.MASK_MOP_ID,
            SOHD_CREATE_EMP_ID: a.MASK_SOHD_CREATE_EMP_ID,
            WH_ID: a.MASK_WH_ID,
            TAX_FORM_ID: a.MASK_TAX_FORM_ID,
            VAN_RT_ID: a.MASK_VAN_RT_ID,
            PAY_TERM_ID: a.MASK_PAY_TERM_ID,
            SOHD_CUST_PO_NO: a.MASK_SOHD_CUST_PO_NO,
            SOHD_CUST_PO_DATE: changeDateFormatMMDD(a.MASK_SOHD_CUST_PO_DATE),
            CUST_ID: a.MASK_CUST_ID,
            CUST_NAME: a.CUST_NAME,
            CBILL_ADD1: a.MASK_CBILL_ADD1,
            CBILL_ADD2: a.MASK_CBILL_ADD2,
            CBILL_ADD_GEOG_ID: a.MASK_CBILL_ADD_GEOG_ID,
            CBILL_ADD_PIN: a.MASK_CBILL_ADD_PIN,
            CSHIP_ADD1: a.MASK_CSHIP_ADD1,
            CSHIP_ADD2: a.MASK_CSHIP_ADD2,
            CSHIP_ADD_GEOG_ID: a.MASK_CSHIP_ADD_GEOG_ID,
            CSHIP_ADD_PIN: a.MASK_CSHIP_ADD_PIN,
            SOHD_ROUND_OFF_AMT: "0.00",
            SOHD_TOT_BASE_CRNC_AMT: a.MASK_SOHD_TOT_AMT,
            SOHD_TOT_AMT: a.MASK_SOHD_TOT_AMT,
            DELIVERY_INSTR: a.MASK_DELIVERY_INSTR,
            BILLING_INSTRUCTION: a.MASK_BILLING_INSTRUCTION,
            PRINT_HEADING: a.MASK_PRINT_HEADING,
            PRINT_MESSAGE: null,
            DEFINED_BY: a.MASK_DEFINED_BY,
            STATUS: a.MASK_STATUS,
            ENTERED_BY: auth.UserId,
            TAX_AREA_ID: a.MASK_TAX_AREA_ID,
            EVAL_BY_LOT_TAG: a.MASK_EVAL_BY_LOT_TAG,
            REMARKS: a.MASK_REMARKS,
            TRANSCHARGE_ID: a.MASK_TRANSCHARGE_ID,
            TRANSCHARGE_RATE: a.MASK_TRANSCHARGE_RATE,
            SALES_AREA_ID: a.MASK_SALES_AREA_ID,
            SHIP_SL_NO: a.MASK_SHIP_SL_NO?.toString(),
            SALESMAN_PERC: a.MASK_SALESMAN_PERC,
            CBILL_CONT_FNAME: a.MASK_CBILL_CONT_FNAME,
            ESPECIE: a.MASK_ESPECIE,
            SERIE: a.MASK_SERIE,
            CIF_FOB: a.MASK_CIF_FOB,
            Param52: "000",

        // EVAL_BY_LOT_TAG: "N",
        // SHIP_SL_NO: "1",
        // CBILL_CONT_FNAME: "A",
        }));

        const salesOrderDtl = autoFOCProductData.map((a) => ({
            COMP_ID: auth.CompId,
            DETL_ID: a.MASK_SEQUENCE!=null?a.MASK_SEQUENCE.toString():a.MASK_SEQUENCE,
            SODT_ID: a.MASK_SODT_ID,
            SOHD_ID: autoFocData[0].MASK_SO_ID,
            PROD_ID: a.MASK_PROD_ID,
            PROD_SMALL_DESC: a.PROD_SMALL_DESC,
            SODT_PROD_STK_TYPE:
      a.STOCK_TYPE === "Inventory" || a.STOCK_TYPE === "1" ? "1" : "2",
            SODT_PACK_UOM_CODE:
      a.MASK_PACK_UOM_CODE === null ? "EA" : a.MASK_PACK_UOM_CODE,
            SODT_TOT_ORD_QTY: a.TOT_ORD_QTY.toString(),
            SODT_TOT_REL_QTY: a.TOT_REL_QTY.toString(),
            SODT_TOT_BACK_QTY: a.MASK_TOT_BACK_QTY.toString(),
            SODT_TOT_DROP_QTY: a.MASK_TOT_DROP_QTY.toString(),
            SODT_TOT_INV_QTY: a.TOT_INV_QTY.toString(),
            SODT_CASE_UOM_CODE: a.CASE_TYPE,
            SODT_CASE_ORD_QTY: a.CASE_ORD_QTY.toString(),
            SODT_CASE_REL_QTY: a.CASE_REL_QTY.toString(),
            SODT_CASE_FACTOR: a.MASK_CASE_FACTOR.toString(),
            SODT_PROD_BATCH_NO: a.PROD_LOT_NO,
            PRICE_LIST_NO: a.PROD_LOT_NO,
            SODT_CDR_DISC: a.CDR_DISC,
            SODT_EUS_DISC_PERC: a.EUS_DISC_PERC.toString(),
            SODT_EUS_DISC: a.EUS_DISC.toString(),
            SODT_TRADE_DISC: a.MASK_TRADE_DISC.toString(),
            SODT_PROD_PRICE: a.PROD_PRICE.toString(),
            SODT_PROD_BASE_PRICE: a.BASE_PRICE.toString(),
            SODT_PROD_VAL: a.MASK_PROD_VAL,
            SODT_VAL_BASE_CRNC: a.MASK_VAL_BASE_CRNC.toString(),
            SODT_SPLCON_TAX: a.MASK_SPLCON_TAX.toString(),
            SODT_TOT_TAX: a.MASK_TOT_TAX.toString(),
            EVALUATE_BY: a.MASK_EVAL_BY_LOT_TAG,
            STATUS: "N",
            ENTERED_BY: auth.UserId,
            SODT_TOT_VAT: a.MASK_SODT_TOT_VAT.toString(),
            SODT_EUS_DISC_PERC_TAG: a.MASK_SODT_EUS_DISC_PERC_TAG,
            SOHD_SO_DATE: changeDateFormatMMDD(currentDate),
            SODT_TRANS_VAL: a.MASK_SODT_TRANS_VAL.toString(),
            SODT_CDR_DISC_PERC: a.MASK_SODT_CDR_DISC_PERC.toString(),
            SODT_CDR_DISC_PERC_TAG: a.MASK_SODT_CDR_DISC_PERC_TAG,
            SODT_PRICE_OR_TAG: a.MASK_SODT_PRICE_OR_TAG,
            SODT_UPPER_BAND: a.MASK_SODT_UPPER_BAND,
            SODT_LOWER_BAND: a.MASK_SODT_LOWER_BAND,
            SODT_PRL_PRICE: a.MASK_SODT_PRL_PRICE,
            DIVN_ID: a.MASK_DIVN_ID,
            EUS_DISC_APP_TO: a.MASK_EUS_DISC_APP_TO,
            PRODUCT_MRP: a.MASK_PRODUCT_MRP.toString(),
            IUKEY: a.MASK_IUKEY,
            OLD_STK_ONLY: "N",
            BASE_PROD_CODE: a.BASE_PROD_CODE,
            RBO_REAS_CODE: a.RBO_REAS_CODE,
            BASKET_CODE: null,
            IS_FREE_PRODUCT: null,
            MASK_SCHM_ID: a.MASK_SCHM_ID
        }));
        let schmData = autoFOCProductData.map(
            (a) => ({
                COMP_ID: auth.CompId,
                SODT_ID: a.MASK_SODT_ID,
                SOHD_ID: autoFocData[0].MASK_SO_ID,
                PROD_ID: a.PRODUCT_CODE,
                PROD_SMALL_DESC: a.PROD_SMALL_DESC,
                PROD_STK_TYPE:
      a.STOCK_TYPE === "Inventory" || a.STOCK_TYPE === "1" ? "1" : "2",
                PACK_UOM_CODE: a.MASK_PACK_UOM_CODE,
                TOT_ORD_QTY: a.TOT_ORD_QTY.toString(),
                TOT_REL_QTY: a.TOT_REL_QTY.toString(),
                TOT_BACK_QTY: a.MASK_TOT_BACK_QTY.toString(),
                TOT_DROP_QTY: a.MASK_TOT_DROP_QTY.toString(),
                PROD_BATCH_NO: a.PROD_LOT_NO,
                EVALUATE_BY: a.MASK_EVAL_BY_LOT_TAG,
                ENTERED_BY: auth.UserId,
                EUS_DISC_PERC_TAG: "Y",
                SO_DATE: changeDateFormatMMDD(autoFocData[0].SO_DATE), //(dd / MM / yyyy),
                CDR_DISC_PERC_TAG: a.MASK_SODT_CDR_DISC_PERC_TAG,
                PRICE_OR_TAG: a.MASK_SODT_PRICE_OR_TAG,
                PRL_PRICE: a.MASK_SODT_PRL_PRICE,
                DIVN_ID: a.MASK_DIVN_ID,
                SCHM_ID: ("CIL|" + a.FREE_SCHM_CODE).toString(),
            })
        // }
        );
        let stockData = autoFOCProductData.map((a) => ({
            COMP_ID: auth.CompId,
            DIVN_ID: a.MASK_DIVN_ID,
            WH_ID: autoFocData[0].MASK_WH_ID,
            TYPE_ID: a.STOCK_TYPE === "Inventory" || a.STOCK_TYPE === "1" ? "1" : "2",
            PROD_ID: a.MASK_PROD_ID,
            BATCH_NO: a.PROD_LOT_NO,
            ALLOCATED_QTY: (
                Number(a.TOT_REL_QTY) - Number(a.MASK_TOT_REL_QTY)
            ).toString(),
            BASE_PROD_CODE: a.PRODUCT_CODE,
            BASE_PROD_LOT: a.BASE_PROD_LOT,
            BASE_ALLOCATED_QTY: a.BASE_PROD_ALLOC,
        }));

        let sODetailsData = autoFOCProductData.map((a) => ({
            COMP_ID: a.COMP_ID,
            MASK_SODT_ID: a.MASK_SODT_ID,
            DIVISION: a.DIVISION,
            MASK_PROD_ID: a.MASK_PROD_ID,
            STOCK_TYPE:
    a.STOCK_TYPE === "Inventory" || a.STOCK_TYPE === "1" ? "1" : "2",
            PRODUCT_CODE: a.PRODUCT_CODE,
            PROD_SMALL_DESC: a.PROD_SMALL_DESC,
            PROD_LOT_NO: a.PROD_LOT_NO,
            PRICE_LIST_NO: a.PRICE_LIST_NO,
            CASE_TYPE: a.CASE_TYPE,
            CDR_DISC: a.CDR_DISC,
            EUS_DISC_PERC: a.EUS_DISC_PERC.toString(),
            EUS_DISC: a.EUS_DISC.toString(),
            CASE_ORD_QTY: a.CASE_ORD_QTY.toString(),
            PACK_ORD_QTY: a.PACK_ORD_QTY.toString(),
            TOT_ORD_QTY: a.TOT_ORD_QTY.toString(),
            PROD_PRICE: a.PROD_PRICE.toString(),
            BASE_PRICE: a.BASE_PRICE.toString(),
            CASE_REL_QTY: a.CASE_REL_QTY.toString(),
            PACK_REL_QTY: a.PACK_REL_QTY.toString(),
            TOT_REL_QTY: a.TOT_REL_QTY.toString(),
            TOT_INV_QTY: a.TOT_INV_QTY.toString(),
            MASK_PROD_VAL: a.MASK_PROD_VAL,
            MASK_SODT_PROD_STK_TYPE: a.MASK_SODT_PROD_STK_TYPE,
            MASK_PACK_UOM_CODE: a.MASK_PACK_UOM_CODE,
            MASK_TOT_BACK_QTY: a.MASK_TOT_BACK_QTY.toString(),
            MASK_TOT_DROP_QTY: a.MASK_TOT_DROP_QTY.toString(),
            MASK_TRADE_DISC: a.MASK_TRADE_DISC.toString(),
            MASK_VAL_BASE_CRNC: a.MASK_VAL_BASE_CRNC.toString(),
            MASK_SPLCON_TAX: a.MASK_SPLCON_TAX.toString(),
            MASK_TOT_TAX: a.MASK_TOT_TAX.toString(),
            MASK_SODT_TOT_VAT: a.MASK_SODT_TOT_VAT.toString(),
            MASK_CASE_FACTOR: a.MASK_CASE_FACTOR.toString(),
            MASK_STATUS: a.MASK_STATUS,
            // MASK_UPDATE_COUNT: a.MASK_UPDATE_COUNT,
            MASK_EXPORTED: a.MASK_EXPORTED,
            MASK_FIRST_ENTERED_BY: a.MASK_FIRST_ENTERED_BY,
            MASK_FIRST_ENTERED_ON: a.MASK_FIRST_ENTERED_ON,
            MASK_LAST_MODIFIED_BY: a.MASK_LAST_MODIFIED_BY,
            MASK_LAST_MODIFIED_ON: a.MASK_LAST_MODIFIED_ON,
            MASK_IUKEY: a.MASK_IUKEY,
            MASK_SEQUENCE: a.MASK_SEQUENCE!=null?a.MASK_SEQUENCE.toString():a.MASK_SEQUENCE,
            EXTENDED_PRICE: a.EXTENDED_PRICE.toString(),
            MASK_SODT_EUS_DISC_PERC_TAG: a.MASK_SODT_EUS_DISC_PERC_TAG,
            MASK_SODT_TRANS_VAL: a.MASK_SODT_TRANS_VAL.toString(),
            MASK_SODT_CDR_DISC_PERC: a.MASK_SODT_CDR_DISC_PERC.toString(),
            MASK_SODT_CDR_DISC_PERC_TAG: a.MASK_SODT_CDR_DISC_PERC_TAG,
            MASK_SODT_PRICE_OR_TAG: a.MASK_SODT_PRICE_OR_TAG,
            MASK_SODT_UPPER_BAND: a.MASK_SODT_UPPER_BAND,
            MASK_SODT_LOWER_BAND: a.MASK_SODT_LOWER_BAND,
            MASK_SODT_PRL_PRICE: a.MASK_SODT_PRL_PRICE,
            MASK_SOHD_ID: a.MASK_SOHD_ID,
            MASK_DIVN_ID: a.MASK_DIVN_ID,
            MASK_EVAL_BY_LOT_TAG: a.MASK_EVAL_BY_LOT_TAG,
            MASK_EUS_DISC_APP_TO: a.MASK_EUS_DISC_APP_TO,
            MASK_PRODUCT_MRP: a.MASK_PRODUCT_MRP.toString(),
            MASK_OLD_STK_ONLY: a.MASK_OLD_STK_ONLY,
            RBO_REAS_CODE: a.RBO_REAS_CODE,
            STOCK_TYP:
    a.STOCK_TYPE === "Inventory" || a.STOCK_TYPE === "1" ? "1" : "2",
            DESCRIPTION: a.DESCRIPTION,
            TOT_AVL_QTY: a.TOT_AVL_QTY,
            FREE_SCHM_CODE: a.FREE_SCHM_CODE,
            BASE_PROD_CODE: a.BASE_PROD_CODE,
            BASE_PROD_LOT: a.BASE_PROD_LOT,
            BASE_PROD_ALLOC: a.BASE_PROD_ALLOC,
            MASK_UPDATE_COUNT: a.MASK_UPDATE_COUNT.toString(),
            BASKET_CODE: null,
            IS_FREE_PRODUCT: null,
        }));

        let obj = {
            UserId: auth.UserId,
            CICode: auth.CICode,
            IUKey: "2",
            SalesOrderHdr: _salesOrderHdr,
            SalesOrderDtl: salesOrderDtl,
            SchmData: schmData,
            StockData: stockData,
            DocPayTermData: docPayTermData,
            SODetailsData: sODetailsData,
            OEMORDER: "",
        };
        console.log("Save Allocation",obj);
        return obj;
    };
    const saveFocData = async () => {
        setLoading(true);
        try{
            const payload = createSavePayload();
            console.log("pay load for save ", payload);
            // return;
            const res = await Axios.post(INSERT_SO, JSON.stringify(payload), {
                headers: { "Content-Type": "application/json" },
            });
            console.log(res,"SaveRes");
            if (res.data?.status == "SUCCESS"){
                toast.success("Data Saved Successfully", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                getAutoFOCProductDetailsData();
            }
        }catch(ex){
            console.log(ex);
        }finally{
            setLoading(false);
        }
    };
    const getCustomerInfoObj =async()=>{
        const custinfo = `${apicalling}CICode=${auth.CICode}&strCustId=${encodeURIComponent(data.CUST_ID)}`;
        const custinfo_res = await Axios.get(custinfo);
        const objCustInfo = custinfo_res.data.Table.map((val) => ({
            MASK_CURRENCY_ID: val.MASK_CURRENCY_ID,
            MASK_CURRENCY_NAME: val.MASK_CURRENCY_NAME,
            MASK_MOP_ID: val.MASK_MOP_ID,
            MASK_MOP_DESC: val.MASK_MOP_DESC,
            MASK_PAY_TERM_ID: val.MASK_PAY_TERM_ID,
            MASK_PAY_TERM_DESC: val.MASK_PAY_TERM_DESC,
            MASK_TAX_FORM_ID: val.MASK_TAX_FORM_ID,
            MASK_TAX_FORM_DESC: val.MASK_TAX_FORM_DESC,
            MASK_VAN_RT_ID: val.MASK_VAN_RT_ID,
            MASK_VAN_RT_DESC: val.MASK_VAN_RT_DESC,
            MASK_CUST_DOC_DISC: val.MASK_CUST_DOC_DISC.toString(),
            CBILL_ADD1: val.CBILL_ADD1,
            CBILL_ADD2: val.CBILL_ADD2,
            BILL_STATE: val.BILL_STATE,
            CBILL_ADD_GEOG_ID: val.CBILL_ADD_GEOG_ID,
            BILL_TOWN: val.BILL_TOWN,
            CBILL_ADD_PIN: val.CBILL_ADD_PIN,
            CSHIP_ADD1: val.CSHIP_ADD1,
            CSHIP_ADD2: val.CSHIP_ADD2,
            SHIP_STATE: val.SHIP_STATE,
            CSHIP_ADD_GEOG_ID: val.CSHIP_ADD_GEOG_ID,
            SHIP_TOWN: val.SHIP_TOWN,
            CSHIP_ADD_PIN: val.CSHIP_ADD_PIN,
            MASK_PAY_TERM_TYPE: val.MASK_PAY_TERM_TYPE,
            MASK_TAX_AREA_ID: val.MASK_TAX_AREA_ID,
            MASK_AREA_NAME: val.MASK_AREA_NAME,
            MASK_TRANS_CHARGE_ID: val.MASK_TRANS_CHARGE_ID,
            MASK_TRANSCHARGE_DESCRIPTION: val.MASK_TRANSCHARGE_DESCRIPTION,
            MASK_TRANSCHARGE_RATE: val.MASK_TRANSCHARGE_RATE,
            MASK_SALES_EXEC_EMP_ID: val.MASK_SALES_EXEC_EMP_ID,
            MASK_EMP_NAME: val.MASK_EMP_NAME,
            MASK_CUST_DELIVERY_INST: val.MASK_CUST_DELIVERY_INST,
            MASK_CUST_BILLING_INST: val.MASK_CUST_BILLING_INST,
            MASK_SALES_AREA_ID: val.MASK_SALES_AREA_ID,
            MASK_CSHIP_SRL_NO: val.MASK_CSHIP_SRL_NO,
            MASK_CBILL_CONT_FNAME: val.MASK_CBILL_CONT_FNAME,
            MASK_CIF_FOB: val.MASK_CIF_FOB,
            EMP_ID: val.EMP_ID,
            SHIPEMP_NAME: val.SHIPEMP_NAME,
            DAY_OF_WEEK: val.DAY_OF_WEEK.toString(),
            
        }));
        return objCustInfo;
    };
    const invoiceCall =async () => {
        for (let item of autoFOCProductData) {
            const ord = Number(item.TOT_ORD_QTY);
            const inv = Number(item.TOT_INV_QTY);
            const rel = Number(item.TOT_REL_QTY);
            const drop = Number(item.MASK_TOT_DROP_QTY);
        
            if (ord < (inv + rel + drop)) {
                toast.error("The sum of invoice, release and drop quantity should be less than equal to order quantity for Product:"+item.PRODUCT_CODE, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;                
            }
        }
        setLoading(true);
        // Create Invoice
        let modelInvProdList = autoFOCProductData.map((a) => ({
            productCode: a.MASK_PROD_ID,
            productName: a.PROD_SMALL_DESC,
            lotNo: a.PROD_LOT_NO,
            mrp: a.MASK_PRODUCT_MRP.toString(),
            productPrice: a.MASK_SODT_PRL_PRICE,
            extendedPrice: a.EXTENDED_PRICE.toString(),
            PACK_ORD_QTY: a.TOT_ORD_QTY.toString(),
            TOT_INV_QTY: a.TOT_INV_QTY.toString(),
            TOT_REL_QTY: a.TOT_REL_QTY.toString(),
            TOT_BACK_QTY: a.MASK_TOT_BACK_QTY.toString(),
            MASK_STATUS: a.MASK_STATUS,
            reason: a.RBO_REAS_CODE,
        }));
        const objCustInfo = await getCustomerInfoObj();
        let obj1 = {
            ciCode: auth.CICode,
            invId: null,
            soHrdId: autoFocData[0].MASK_SO_ID,
            userId: auth.UserId,
            custId: autoFocData[0].MASK_CUST_ID,
            compId: auth.CompId,
            eInvApplicability: auth.EInvApplicability,
            eInvIRPUserPassword: auth.EInvIRPUserPassword,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvGSTNO: auth.EInvGSTNO,
            printFormatCode: auth.PrintFormatCode,
            popupRes: "false",
            objCustInfo: objCustInfo,
            clsModelInvProdList: modelInvProdList,
            invoiceNo: null,
            invoiceId: null,
            invhId: null,
            invNo: null,
            soStatus: null,
            compGSTDate: null,
            compState: null,
            eInvoiceErrorCode: null,
            eInvoiceErrorMessage: null,
        };
        console.log("createinv",obj1);
        // return;
        Axios
            .post(CREATE_INVOICE, JSON.stringify(obj1), {
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                if(res.data.Status=="Error"){
                    if(res?.data?.Message?.includes("NOSTOCKLINE")){
                        const parts = res?.data?.Message?.split("-");
                        setRestrictedMsg(`Product Code - ${parts[1]} and Lot No - ${parts[2].split(",")[0]} is missing in stock`);
                        setConcurrentUser(true);
                    }
                    else if(res?.data?.Message?.includes("INSUFFICIENTSTOCK")){
                        const parts = res?.data?.Message?.split("-");
                        setRestrictedMsg(`Stock is not available for Product Code - ${parts[1]} and Lot No - ${parts[2].split(",")[0]}`);
                        setConcurrentUser(true);
                    }
                    else if(res.data.Message === "CONCURRENT_ORDER_INVOICE"){
                        setConcurrentUser(true);
                        setRestrictedMsg("This order is in use by another user. Please try after sometime.");
                    }else{
                        toast.error(res.data.Message, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                    }
                }
                else{
                    getAutoFOCProductDetailsData();
                    let objInvoice = [{
                        CICode: auth.CICode,
                        InvoiceId: res.data.clsMGenerateInv.InvoiceId,
                        CompId: auth.CompId,
                        EInvPaymentUPI: auth.EInvPaymentUPI,
                        InvoiceDate: format(new Date(), "dd/MM/yyyy"),
                        DistTag: auth.DistTag,
                        EInvApplicability: auth.EInvApplicability,
                        EInvB2CQR: auth.EInvB2CQR,
                    }];
                    setPrintInvoiceModalData(objInvoice);
                    setInvoicePopup(true);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.response.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                // console.log("error,", error);
            }).finally(()=>{
                setLoading(false);
            });
    };
    const handleKeyPress = (e) => {
        [".", "+", "-", "e", "E"].includes(e.key) && e.preventDefault();
    };
    const updateQuantity = (e, data) => {
        const updatedData = [...SalesOrderData];
        console.log(data,"rowData");
        const index = updatedData.findIndex(item => item.PRODUCT_CODE+item.PROD_BATCH_NO === data.PRODUCT_CODE+data.PROD_BATCH_NO); // Assuming PRODUCT_CODE is unique for each row

        if (index !== -1) {
            updatedData[index] = {
                ...updatedData[index],
                PACK_REL_QTY: e.target.value // Update only the TOT_REL_QTY field
            };

            // Now set the updated data to the state
            console.log(updatedData,"updatedData");
            setSalesOrderData(updatedData);
        }
        // setReleaseQty(e.value);


        // setAddToCartData([...])
    };


    const handleDialog = (data) => {
        getReallocateData(data);
        setShowDialog(true);
        // setAddToCartData(data);
        // addToCartValidations();
        // setAddToCartData(data);
    };

    const footerContent = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary me-3" onClick={()=>addToCartValidations()}>Add to Cart</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => {setShowDialog(false);setSalesOrderData();}}>Cancel</button>
            </div>
        </div>
    );

    useEffect(() => {
        getAutoFOCProductDetailsData();
        getAutoFOCBySOHD_ID_Data();
        // getCustInfo();
    }, []);

    if(loading){
        return(<Loader/>);
    }else{
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Free Invoice Details</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end mb-2">
                                <Link to="/salesmanagement/freeinvoice?type=Auto">
                                    <button type="button" className="btn btn-outline-primary me-3"><Fa.FaLongArrowAltLeft className="backIcon" /> Back to all Records</button>
                                </Link>
                                <button type="button" className="btn btn-primary me-3" onClick={()=>UpdateSalesCondition("FOCUP")}>
                                Save
                                </button>
                                <button type="button" className="btn btn-primary" onClick={()=>UpdateSalesCondition("INV")} disabled={btnDisable}>
                                Create Invoice
                                </button>
                            </div>
                        </div>
                    </div>
                    <section className="">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    paginator
                                    rows={10}
                                    value={autoFOCProductData}
                                    tableStyle={{ minWidth: "60rem" }}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    // showGridlines
                                    stripedRows
                                    scrollable
                                    emptyMessage="No Record found"
                                >
                                    <Column field="MASK_SCHM_CODE" header="Scheme Code"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="PRODUCT_CODE" header="Product Code"
                                    // style={{ minWidth: "10rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."></Column>
                                    <Column field="PROD_SMALL_DESC" header="Product Description"
                                        style={{ minWidth: "17rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="PROD_LOT_NO" header="Lot Number"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="TOT_ORD_QTY" header="Order Qty"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="TOT_INV_QTY" header="Invoiced Qty"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="TOT_REL_QTY" header="Release Qty"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column field="MASK_TOT_BACK_QTY" header="Back Qty"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..." />
                                    <Column header="Action " body={(rowData) => (
                                        <div className="action-icon">
                                            <button
                                                className="grid-icon-img"
                                                title="View/Edit"
                                                onClick={() => handleDialog([rowData])}
                                            >
                                                <img
                                                    alt="InnoRise"
                                                    src={require("../../Assets/Images/ViewEdit.png")}
                                                />
                                            </button>
                                        </div>
                                    // <img
                                    //     alt="View/Edit"
                                    //     width="20px"
                                    //     src={require("../../Assets/Images/ViewEdit.png")}
                                    //     onClick={() => handleDialog([rowData])}
                                    //     style={{ cursor: "pointer", marginRight: "10px" }}
                                    // />
                                    )}></Column>
                                </DataTable>
                            </div>
                        </div>
                    </section>
                    {showDialog &&
                    <div className="">
                        <Dialog
                            header="Products"
                            visible={showDialog}
                            style={{ width: "80vw" }}
                            onHide={() => setShowDialog(false)}
                            closable={false}
                            resizable={false}
                            draggable={false}
                            footer={footerContent}
                        >
                            <div className="col-md-12 col-lg-12 col-sm-12">
                                <div className="DataTable mb-3">
                                    <DataTable
                                        value={SalesOrderData}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        selectionMode="checkbox"
                                        // selection={selectedreceivableDocumentData}
                                        // rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        showSelectAll={false}
                                        // onSelectionChange={(e) => {
                                        //     setSelectedreceivableDocumentData(e.value);
                                        // }}
                                        emptyMessage="No Records found to display"
                                        tableStyle={{ minWidth: "20rem" }}
                                    >
                                        <Column
                                            field="PRODUCT_CODE"
                                            header="Product Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="MASK_PROD_PACK_DESC"
                                            header="Product Description"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="PROD_BATCH_NO"
                                            header="Lot Number"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="BALANCED_QTY"
                                            header="Available Qty"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="PACK_REL_QTY"
                                            // value={}
                                            header="Release Qty"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            body={(rowData) =>

                                                <InputText
                                                    type="number"
                                                    className="form-control"
                                                    value={rowData.PACK_REL_QTY}
                                                    onChange={(e) => updateQuantity(e, rowData)}
                                                    onKeyPress={handleKeyPress}
                                                    // disabled={selectedDisableRow.some((a)=>a.PRODUCT_CODE+a.PROD_LOT_NO===rowData.MASK_PROD_ID+rowData.PROD_BATCH_NO)}
                                                />
                                            }
                                        ></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                    }
                </div>
                {invoicePopup ? <Print /> : null}
                <Dialog
                    header="Confirmation"
                    visible={concurrentUser}
                    style={{ width: "50vw" }}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                        <p>{restrictedMsg}</p>
                    </div>
                    <div className="float-end mt-4">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={() => {
                                setConcurrentUser(false);
                                nav("/salesmanagement/freeinvoice");
                            }}
                        >
                  OK
                        </button>
                    </div>
                </Dialog>
            </>
        );
    }
}